import { render } from "./editor.vue?vue&type=template&id=31dd82b7&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=31dd82b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kenyo\\Documents\\dev\\passwords\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dd82b7"]])

export default __exports__